/**
 * An automation drawn as a path: one thin line through its nodes, from how it starts to where each run
 * ends up. Long instructions fold away under their step.
 */
const AutomationPath = ({ nodes }) => {
  return (
    <ol className="automations-path">
      {nodes.map((node) => (
        <li key={node.id} className="automations-path__node" data-role={node.role}>
          <span className="automations-path__mark" aria-hidden="true" />
          <div className="automations-path__content">
            <p className="automations-path__title">{node.title}</p>
            {node.body && <p className="automations-path__body">{node.body}</p>}
            {node.instructions && (
              <details className="automations-path__instructions">
                <summary>Pieve's instructions</summary>
                <p>{node.instructions}</p>
              </details>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default AutomationPath;
